import { Controller } from '@hotwired/stimulus'
import 'form-request-submit-polyfill'

export default class extends Controller<HTMLFormElement> {
  static targets = ['button', 'input']

  static values = {
    text: String,
  }

  declare buttonTarget: HTMLButtonElement
  declare inputTarget: HTMLInputElement
  declare textValue: string

  connect(): void {
    this.setupSubmitListener()
    this.setupEnterListener()

    if (this.inputTarget.value) {
      this.buttonTarget.classList.remove('hidden')
      this.buttonTarget.classList.add('flex')
    } else {
      this.buttonTarget.classList.add('hidden')
      this.buttonTarget.classList.remove('flex')
    }
  }

  disconnect(): void {
    this.removeSubmitListener()
    this.removeEnterListener()
  }

  reset() {
    this.element.reset()
  }

  onInputChange(event) {
    this.textValue = event.target.value
  }

  textValueChanged() {
    if (this.textValue) {
      this.buttonTarget.classList.remove('hidden')
      this.buttonTarget.classList.add('flex')
    } else {
      this.buttonTarget.classList.add('hidden')
      this.buttonTarget.classList.remove('flex')
    }
  }

  onSubmitEnd = (event: any): void => {
    if (event.detail.success) {
      this.reset()
    }
  }

  setupSubmitListener() {
    this.element.addEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  removeSubmitListener() {
    this.element.removeEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  onKeyDown = (event: KeyboardEvent): void => {
    if (event.code === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  setupEnterListener() {
    this.element.addEventListener('keydown', this.onKeyDown)
  }

  removeEnterListener() {
    this.element.removeEventListener('keydown', this.onKeyDown)
  }
}
